/* NB PDP V3 — behaviour layer.
   Everything here is PROGRESSIVE ENHANCEMENT. With JavaScript disabled the page is complete: anchors
   navigate, all How-To steps are visible, announcement messages read once, the in-page CTA works, and
   no control renders that cannot act. DEFECT-11. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* DEFECT-02 · jump-nav active state. Never in markup. */
  (function jumpNav() {
    var nav = document.querySelector('[data-nb-jumpnav]');
    if (!nav || !('IntersectionObserver' in window)) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-nb-jumplink]'));
    var map = {}, targets = [];
    links.forEach(function (a) {
      var id = (a.getAttribute('href') || '').replace(/^#/, '');
      if (!id) return;
      var el = document.getElementById(id);
      if (!el) return;               // fail quiet: a link with no target simply never activates
      map[id] = a;
      targets.push(el);
    });
    if (!targets.length) return;

    var current = null;
    function setCurrent(id) {
      if (id === current) return;
      current = id;
      links.forEach(function (a) { a.removeAttribute('aria-current'); });
      if (map[id]) map[id].setAttribute('aria-current', 'true');
    }
    var io = new IntersectionObserver(function (entries) {
      var best = null;
      entries.forEach(function (e) { if (e.isIntersecting) best = e.target; });
      if (best) setCurrent(best.id);
    }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
    targets.forEach(function (t) { io.observe(t); });

    nav.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-nb-jumplink]');
      if (!a) return;
      var id = (a.getAttribute('href') || '').replace(/^#/, '');
      var el = id && document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      el.setAttribute('tabindex', '-1');
      el.focus({ preventScroll: true });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
  })();

  /* shoppable + in-use video · the control is INJECTED, so it can never render dead */
  (function videoCards() {
    var grids = document.querySelectorAll('[data-nb-sv-grid]');
    if (!grids.length) return;
    Array.prototype.forEach.call(grids, function (grid) {
      Array.prototype.forEach.call(grid.querySelectorAll('.nb-sv__frame'), function (frame) {
        var vid = frame.querySelector('.nb-sv__el');
        if (!vid) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'nb-sv__toggle';
        btn.setAttribute('aria-pressed', 'false');
        if (vid.id) btn.setAttribute('aria-controls', vid.id);
        btn.textContent = 'Play';
        frame.appendChild(btn);

        function stopOthers() {
          Array.prototype.forEach.call(grid.querySelectorAll('.nb-sv__el'), function (o) {
            if (o === vid || o.paused) return;
            o.pause();
          });
        }
        btn.addEventListener('click', function () {
          if (vid.paused) { stopOthers(); vid.play(); } else { vid.pause(); }
        });
        vid.addEventListener('play', function () {
          frame.classList.add('is-playing'); btn.setAttribute('aria-pressed', 'true'); btn.textContent = 'Pause';
        });
        vid.addEventListener('pause', function () {
          frame.classList.remove('is-playing'); btn.setAttribute('aria-pressed', 'false'); btn.textContent = 'Play';
        });

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (en) {
            en.forEach(function (e) { if (!e.isIntersecting && !vid.paused) vid.pause(); });
          }, { threshold: 0.15 }).observe(frame);
        }
      });
    });
  })();
})();
